import { accessControlService } from './accessControl';

export interface TournamentOption {
  id: string;
  name: string;
  logo?: string;
  country?: string;
  slug?: string;
  data_source?: string;
  created_at?: string;
  updated_at?: string;
  active?: boolean;
  organisation_id?: string;
  fixtures_enabled?: boolean;
  standings_enabled?: boolean;
}

export const tournamentService = {
  // Get all tournaments for dropdown (access-controlled)
  async getTournaments(): Promise<TournamentOption[]> {
    try {
      const result = await accessControlService.getTournaments();
      
      if (result.error) {
        console.error('Error fetching tournaments:', result.error);
        return [];
      }

      return result.data || [];
    } catch (error) {
      console.error('Error in getTournaments:', error);
      return [];
    }
  },

  // Get complete tournament details by ID (access-controlled)
  async getTournamentDetails(tournamentId: string): Promise<TournamentOption | null> {
    try {
      const result = await accessControlService.getTournamentDetails(tournamentId);
      
      if (result.error) {
        console.error('Error fetching tournament details:', result.error);
        return null;
      }

      return result.data || null;
    } catch (error) {
      console.error('Error in getTournamentDetails:', error);
      return null;
    }
  },

  // Update tournament details (access-controlled)
  async updateTournamentDetails(tournamentId: string, updates: Partial<TournamentOption>): Promise<{ success: boolean; error?: string }> {
    try {
      const result = await accessControlService.updateTournamentDetails(tournamentId, updates);
      
      if (result.error) {
        console.error('Error updating tournament details:', result.error);
        return { success: false, error: result.error };
      }

      return { success: true };
    } catch (error) {
      console.error('Error in updateTournamentDetails:', error);
      return { success: false, error: 'Failed to update tournament details' };
    }
  }
};
